import createSelector from 'lib/web/createSelector'
import {
  hasMultiplePurchasableOptionsWithPackageUpgradeOrRoomTypeUpgrade,
  hasOptionalExtras,
} from 'checkout/selectors/tourV2Selectors'
import config from 'constants/config'
import { pushWithRegion } from 'actions/NavigationActions'
import { CheckoutPageId } from 'checkout/constants/pages'
import { getCurrentCheckoutPage } from 'checkout/actions/navigateActions'

const tourCheckoutSteps: { [key:string]: App.Checkout.CheckoutStep } = {
  package: {
    label: 'Tour package',
    step: 'tours',
    isRoute: true,
    subSteps: [],
  },
  extras: {
    label: 'Optional experiences',
    step: 'tours-optional-extras',
    isRoute: true,
    subSteps: [],
  },
  purchase: {
    label: 'Review & payment',
    step: CheckoutPageId.Purchase,
    isRoute: true,
    subSteps: [],
  },
}

export const isStepTour = (step: string) => {
  return Object.values(tourCheckoutSteps).some(
    tourStep => tourStep.step === step && step !== tourCheckoutSteps.purchase.step,
  )
}

export const getTourCheckoutSteps = createSelector(
  hasMultiplePurchasableOptionsWithPackageUpgradeOrRoomTypeUpgrade,
  hasOptionalExtras,
  (hasPackageUpgrade, hasExtras): App.Checkout.CheckoutStep[] => {
    const steps = []
    if (hasPackageUpgrade) steps.push(tourCheckoutSteps.package)
    if (hasExtras && config.TOUR_OPTIONAL_EXTRAS_ENABLED) steps.push(tourCheckoutSteps.extras)
    steps.push(tourCheckoutSteps.purchase)
    return steps
  },
)

export const navigateToTourCheckoutStep = () => {
  return (dispatch, getState) => {
    const state = getState() as App.State
    const steps = getTourCheckoutSteps(state)
    const firstStep = steps?.[0]
    if (firstStep) {
      dispatch(pushWithRegion(`/checkout/${firstStep.step}`))
    }
  }
}

export const navigateToNextStepTourCheckout = () => {
  return (dispatch, getState) => {
    const state = getState() as App.State
    const steps = getTourCheckoutSteps(state)
    const currentStep = getCurrentCheckoutPage(state)
    const currentIndex = steps.findIndex(step => step.step === currentStep)
    const nextStep = steps?.[currentIndex + 1]
    if (nextStep) {
      dispatch(pushWithRegion(`/checkout/${nextStep.step}`))
    }
  }
}

export const getNextTourCheckoutStep = createSelector(
  getTourCheckoutSteps,
  getCurrentCheckoutPage,
  (tourSteps, currentStep) => {
    const currentIndex = tourSteps.findIndex(step => step.step === currentStep)
    return tourSteps?.[currentIndex + 1]
  },
)
